import React from 'react';
import { conservativeRating } from '../../utils/playerRanking';

interface ConservativeRatingDisplayProps {
  /** mu */
  rating: number;
  sigma: number;
  isUncertain?: boolean;
  className?: string;
}

/**
 * The number the player lists sort by (conservative rating) as the main figure, with the
 * underlying mu ± sigma next to it, so the order reads correctly.
 */
const ConservativeRatingDisplay: React.FC<ConservativeRatingDisplayProps> = ({
  rating,
  sigma,
  isUncertain = false,
  className = '',
}) => {
  const wrapperClasses = isUncertain
    ? 'inline-flex items-center border border-edge-input rounded-full px-2 py-0.5 bg-surface-subtle'
    : 'inline-flex items-center border border-primary-200 rounded-full px-2 py-0.5 bg-primary-50';
  const mainClasses = isUncertain ? 'text-muted' : 'text-heading';
  const secondaryClasses = isUncertain ? 'text-disabled' : 'text-body';

  return (
    <span className={`${wrapperClasses} ${className}`} data-testid="conservative-rating">
      <span className={`font-mono font-bold ${mainClasses}`}>{conservativeRating(rating, sigma).toFixed(2)}</span>
      <span className={`ml-1.5 font-mono text-xs font-normal ${secondaryClasses}`} data-testid="mu-sigma">
        (μ {rating.toFixed(1)} ± {sigma.toFixed(1)})
      </span>
    </span>
  );
};

export default ConservativeRatingDisplay;
